import React from 'react';
import classNames from 'classnames';
import Icon from '../Icon';

const BrandingFormItem = ({title, children}) => {
    const [expanded, setExpanded] = React.useState(false);
    const handleToggleExpanded = React.useCallback((e) => {
        e.preventDefault();
        setExpanded((prev) => !prev);
    }, []);


    return (
        <div className={classNames('survey-editor-item mb-4', {expanded: expanded})}>
            <header>
                <button onClick={handleToggleExpanded} className="btn btn-link toggle">
                    { expanded ? <Icon icon="arrow-alt-down" /> : <Icon icon="arrow-alt-up" />}
                </button>
                <div className="page-header d-flex flex-column justify-content-center">
                    {title}
                </div>
            </header>
            {expanded && <div className="body">{children}</div>}
        </div>
    );
};

export default BrandingFormItem;
